import { createFileRoute } from "@tanstack/react-router";

const ProjectDetailsRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/projects/$id/")({
	component: ProjectDetailsRoute,
});
